/**
 *
 *@author zcc
 *@date 2022/3/7 17:10
 */
import { BaseServiceImpl } from '@/service/BaseServiceImpl';
import { LocalStorageManager } from '@/db/LocalStorageManager';
import { LocalStorageKey } from '@/constant/LocalStorageKey';
import { AuditLogUrlConfig } from '@/config/AuditLogUrlConfig';

export class AuditLogServiceImpl extends BaseServiceImpl {
  private static service: AuditLogServiceImpl;

  public static getInstance(): AuditLogServiceImpl {
    if (AuditLogServiceImpl.service == null) {
      AuditLogServiceImpl.service = new AuditLogServiceImpl();
    }

    return AuditLogServiceImpl.service;
  }

  /**
   * 获取用户日志列表
   */
  getAuditLogList(actionType?: string, pageNo?: number, pageSize?: number) {
    const user: any = LocalStorageManager.getItem(LocalStorageKey.user);
    if (!user) {
      console.debug('未获取到用户信息');
      return;
    }
    const option = BaseServiceImpl.getGetOption();
    option.url = AuditLogUrlConfig.auditLogList;
    option.params = {
      userId: JSON.parse(user).id,
      actionType: actionType,
      pageNo: pageNo,
      pageSize: pageSize
    };
    return new Promise((resolve, reject) => {
      this.huohuaRequest(option)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  /**
   * 保存用户日志
   */
  saveAuditLog(auditLog: any) {
    const option = BaseServiceImpl.getPostOption();
    option.url = AuditLogUrlConfig.saveAuditLog;
    option.data = JSON.stringify(auditLog);
    option.headers['Content-Type'] = BaseServiceImpl.jsonContentType;
    return new Promise((resolve, reject) => {
      this.huohuaRequest(option)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}
